import Landing from 'nespresso-library/src/core/landing_v2'
import VueMedia from '../media/VueMedia'
import VueAnchor from 'gvue/src/assets/js/directives/VueAnchor'

export default class VueLanding extends Landing {
  static install (Vue, options) {
    let trackingLandingLabel = options.trackingLabelPrefix
    Object.defineProperties(Vue.prototype, {
      $landing: {
        get () {
          return this.$root._landing
        }
      },
      $json: {
        get () {
          return this.$root._json
        }
      },
      $trackingLandingLabel: {
        get: () => trackingLandingLabel,
        set: value => {
          trackingLandingLabel = value
        }
      },
      $mapSectionsName: {
        get: () => ({
          hero: 'Introduction',
          visualVariations: 'Visual variations machines',
          features: 'Benefits',
          range: 'Range',
          recipes: 'Interactive recipes',
          variationsProducts: 'Variations products',
          faq: 'Faq',
          banner: 'Subscription banner',
          why: 'Corporate',
          services: 'Services',
          ...options.sectionTrackingLabels
        })
      }
    })

    Vue.mixin({
      beforeCreate () {
        if (this.$parent === undefined) {
          Vue.util.defineReactive(this, '_json', null)
        } else if (this.$parent === this.$root) {
          this.$root._landing = new VueLanding(this.$root, options)
        }
      }
    })

    Vue.use(VueAnchor)
    Vue.use(VueMedia, {
      breakpoints: {
        S: 767,
        L: 1920,
        XL: Infinity
      },
      getImgSuffix: options.getImgSuffix ? options.getImgSuffix : breakpoint => `_${breakpoint.name.toUpperCase()}`
    })
  }

  constructor (app, options) {
    super(options)

    this.getJSON().then(json => {
      app._json = json
    })
  }
}
